import {
  format,
  roleNames,
  foundingRoleNames,
  segmentNames,
  territoryNames,
} from "../content/en";

export function territoryName(code: string): string {
  return territoryNames[code] ?? code;
}

export function roleName(role: string, founding: boolean): string {
  const table = founding ? foundingRoleNames : roleNames;
  return table[role] ?? role;
}

export function segmentName(key: string | null): string | null {
  if (key === null) return null;
  return segmentNames[key] ?? key;
}

/** Format a minor-unit amount using the candidate's own locale conventions. */
export function money(minor: number, currency: string): string {
  const major = minor / 100;
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency,
      maximumFractionDigits: Number.isInteger(major) ? 0 : 2,
    }).format(major);
  } catch {
    return `${currency} ${String(major)}`;
  }
}

export function percent(basisPoints: number): string {
  return `${String(basisPoints / 100)}%`;
}

export function interpolate(
  template: string,
  values: Readonly<Record<string, string>>,
): string {
  return format(template, values);
}
